module.exports = __webpack_public_path__ + "static/media/take0Points_1.ac3bd5ce.svg";